import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( '[data-component="room-slider"]' ).length ) {
        const section = document.querySelector( '[data-component="room-slider"]' );
        if ( !section ) return;

        const contentEl = section.querySelector( '.js-room-slider-content' );
        const imagesEl = section.querySelector( '.js-room-slider-images' );
        const prevBtn = section.querySelector( '.js-room-prev' );
        const nextBtn = section.querySelector( '.js-room-next' );

        if ( !contentEl || !imagesEl ) return;

        const contentSplide = new Splide( contentEl, {
          type: 'fade',
          rewind: true,
          arrows: false,
          pagination: false,
          drag: false,
        } );

        const imageSplide = new Splide( imagesEl, {
          type: 'fade',
          rewind: true,
          arrows: false,
          pagination: false,
          drag: false,
        } );

        contentSplide.sync( imageSplide );

        contentSplide.mount();
        imageSplide.mount();

        if ( prevBtn ) {
          prevBtn.addEventListener( 'click', () => contentSplide.go( '<' ) );
        }
        if ( nextBtn ) {
          nextBtn.addEventListener( 'click', () => contentSplide.go( '>' ) );
        }
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'room-slider', COMPONENT );
} )( app );
